<template>
  <b-modal
    id="receive-complete"
    modal-class="modal-style"
    ref="modal"
    ignore-enforce-focus-selector=".vld-overlay"
  >
    <template>
      <p class="modal-style-title not-one-row">收款完成</p>
      <div class="modal-style-content">
        請開立發票
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="routeTo">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    orderId: {
      required: false,
      type: [String, Number]
    }
  },
  methods: {
    routeTo() {
      this.$router.push({
        name: '開立發票',
        params: {
          order_id: this.orderId
        }
      });
      this.$emit('confirm');
    }
  }
};
</script>
